export class QueryBase {
  toQueryParams(): URLSearchParams {
    const params = new URLSearchParams();
    const keys = Object.keys(this);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i] as keyof this;
      const val = this[key];
      if (val != null && val != undefined) {
        // Functions (eg. arrow-function properties like isEmptySearch) and plain objects
        // (eg. facets, organisation) can't be meaningfully represented in a query string, so skip them.
        if (
          typeof val === 'function' ||
          (typeof val === 'object' && !(val instanceof Array) && !(val instanceof Date))
        ) {
          continue;
        }
        //By default this is serialized as key=value1,value2 etc
        //But .NET requires key=value1&key=value2
        if (val instanceof Array) {
          val.forEach(element => {
            params.append(key.toString(), element);
          });
        } else {
          params.append(key.toString(), val + '');
        }
      }
    }
    return params;
  }

  toQueryString(): string {
    return this.toQueryParams().toString();
  }

  static toQueryList(list: number[], propertyName: string): string {
    return list
      .map(x => `&${propertyName}=${x}`)
      .join('')
      .substring(1);
  }
}
